export default "__VITE_ASSET__GPqNZIaB__"